import React from "react";
import ReactDOM from "react-dom";
import './index.css';
import { Buffer } from "buffer";
window.Buffer = Buffer;




import App from './App';

ReactDOM.render(<App />, document.getElementById("root"));
